import request from "../utils/request";

export async function GetDraws(payload) {
  return request.get("Draw/GetDraws", {
    params: {
      drawId: payload.drawId,
      title: payload.title,
      description: payload.description,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      isPublished: payload.isPublished
    }
  })
}

export async function CreateNewDraw(payload) {
  return request.post("Draw/Create", payload);
}

export async function DrawTickets(payload) {
  
  return request.get("Draw/DrawTickets", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      drawId: payload.draw ? payload.draw.id : null,
      customerId: payload.customerEmail ? payload.customerEmail.id : payload.customerPhoneNumber ? payload.customerPhoneNumber.id : null,
      ticketCode: payload.ticketCode,
      branchId: payload.branch ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? new Date(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? new Date(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
    }
  })
}

export async function DrawTicketsExcel(payload) {
  return request.get("Draw/DrawTicketsExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      drawId: payload.draw ? payload.draw.id : null,
      customerId: payload.customerEmail ? payload.customerEmail.id : payload.customerPhoneNumber ? payload.customerPhoneNumber.id : null,
      ticketCode: payload.ticketCode,
      branchId: payload.branchId ? payload.branchId : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? new Date(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? new Date(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
    }
  })
}

export async function UpdateDraw(payload) {
  return request.put("Draw/Update", payload);
}

export async function DeleteDraw(payload) {
  return request.delete("Draw/Delete", {
    params: {
      drawId: payload
    }
  })
}

export async function CloneDraw(payload) {
  return request.post("Draw/Clone", {
    params: {
      referenceDrawId: payload
    }
  })
}

export async function PublishDraw(payload) {
  return request.put("Draw/Publish?drawId=" + payload)
}
